import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DiscountComponent } from './components/discount/discount.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordForgottenComponent } from './components/password-forgotten/password-forgotten.component';
import { RegisterComponent } from './components/register/register.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { VerifyAccountComponent } from './components/verify-account/verify-account.component';
import { AuthenticationGuardGuard } from './guards/authentication-guard.guard';
import { BranchComponent } from './components/branch/branch.component';
import { TaxComponent } from './components/tax/tax.component';
import { WarehouseComponent } from './components/warehouse/warehouse.component';
import { ProviderComponent } from './components/provider/provider.component';
import { SourceComponent } from './components/source/source.component';
import { CustomerComponent } from './components/customer/customer.component';
import { ContactComponent } from './components/contact/contact.component';
import { CategoryComponent } from './components/category/category.component';
import { SubCategoryComponent } from './components/sub-category/sub-category.component';
import { ProductComponent } from './components/product/product.component';
import { UserComponent } from './components/user/user.component';
import { ItemComponent } from './components/item/item.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { UtilitiesComponent } from './components/utilities/utilities.component';
import { SettingsComponent } from './components/settings/settings.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { ProfileComponent } from './components/profile/profile.component';
import { HelpComponent } from './components/help/help.component';
import { OrdersComponent } from './components/orders/orders.component';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { ClientComponent } from './components/client/client.component';
import { ProductBundleComponent } from './components/product-bundle/product-bundle.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'Register', component: RegisterComponent },
  { path: 'PasswordForgotten', component: PasswordForgottenComponent },
  { path: 'Dashboard', component: DashboardComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Discount', component: DiscountComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Branch', component: BranchComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Tax', component: TaxComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Warehouse', component: WarehouseComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Provider', component: ProviderComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Source', component: SourceComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Customer', component: CustomerComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Category', component: CategoryComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'SubCategory', component: SubCategoryComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Product', component: ProductComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'ProductDetail', component: ProductDetailComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Item', component: ItemComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'User', component: UserComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Maintenance', component: MaintenanceComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Utilities', component: UtilitiesComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Settings', component: SettingsComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Payments', component: PaymentsComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Profile', component: ProfileComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Help', component: HelpComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Orders', component: OrdersComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Delivery', component: DeliveryComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Client', component: ClientComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Bundle', component: ProductBundleComponent, canActivate: [AuthenticationGuardGuard] },
  { path: 'Welcome', component: WelcomeComponent },
  { path: 'Contact', component: ContactComponent },
  { path: 'VerifyAccount/:activationKey', component: VerifyAccountComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }